import React from 'react';
import { Button } from './ui/button';
import { Award, CheckCircle, Star } from 'lucide-react';

const HERO_BG = "https://images.unsplash.com/photo-1592716287052-b884f81993db?auto=format&fit=crop&q=80";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_empire-lawn-quote/artifacts/k10girhv_Empire%20Lawn%20Care%20and%20Maintenance%20logo%202024.png";

export default function Hero({ onGetQuote }) {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center pt-20"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 hero-overlay" />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <div className="animate-fade-in-up">
          {/* Trust Badge */}
          <div className="inline-flex items-center bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-8">
            <Award className="text-amber-500 mr-2" size={20} />
            <span className="text-white font-inter text-sm">
              Certified in Horticulture & Park Management
            </span>
          </div>
          
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <div className="bg-white rounded-2xl p-10 shadow-2xl">
              <img
                src={LOGO_URL}
                alt="Empire Lawn Care and Maintenance"
                className="h-44 sm:h-56 lg:h-72 w-auto"
              />
            </div>
          </div>
          
          {/* Tagline */}
          <p className="font-oswald text-xl sm:text-2xl text-amber-500 font-semibold mb-4 tracking-wide">
            Professional Property Care You Can Trust
          </p>
          
          {/* Subheading */}
          <p className="font-inter text-base sm:text-lg text-white/90 max-w-2xl mx-auto mb-8 leading-relaxed">
            Lawn care, garden maintenance, and exterior cleaning services 
            in Coffs Harbour. Trusted by homeowners for quality results.
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
            <Button
              onClick={onGetQuote}
              className="bg-amber-600 hover:bg-amber-500 text-white font-oswald font-semibold text-lg px-8 py-6 rounded-md btn-empire w-full sm:w-auto"
              data-testid="hero-get-quote-btn"
            >
              Book a Property Assessment
            </Button>
            <a
              href="#services"
              className="inline-flex items-center justify-center border-2 border-white text-white font-oswald font-medium text-lg px-8 py-5 rounded-md hover:bg-white/10 transition-colors w-full sm:w-auto"
              data-testid="hero-view-services-btn"
            >
              View Our Packages
            </a>
          </div>
          
          {/* Features */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl mx-auto">
            <div className="flex items-center justify-center text-white/90">
              <CheckCircle className="text-amber-500 mr-2" size={20} />
              <span className="font-inter text-sm">Free Quotes</span>
            </div>
            <div className="flex items-center justify-center text-white/90">
              <Star className="text-amber-500 mr-2" size={20} />
              <span className="font-inter text-sm">5-Star Rated</span>
            </div>
            <div className="flex items-center justify-center text-white/90">
              <CheckCircle className="text-amber-500 mr-2" size={20} />
              <span className="font-inter text-sm">Local Coffs Harbour Team</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-white/70 rounded-full mt-2" />
        </div>
      </div>
    </section>
  );
}
